module.exports = __webpack_public_path__ + "static/media/fanhui@3x.fed74961.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fanhui@3x.png
// module id = 1752
// module chunks = 0 1